import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={49}
    height={49}
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_15370_1251)">
      <circle cx={24.5} cy={20.5} r={19.5} fill="#1E1F22" />
      <circle cx={24.5} cy={20.5} r={19} stroke="#485359" />
    </g>
    <path
      d="M32.2788 21L22.4028 30.5349L19.7207 27.8881L26.6982 21L19.7207 14.1142L22.4051 11.4651L32.2788 21Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_15370_1251"
        x={0.3}
        y={0.3}
        width={48.4}
        height={48.4}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2.35} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15370_1251"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15370_1251"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SVGComponent;
